import alt from "../alt";
import ImageActions from "../actions/imageActions";

class ImageStore {
	constructor() {
		this.frames = [];
		this.frameCount = 876;
		this.isLoading = false;
		this.framesLoaded = 0;

		this.bindListeners({
			handleInit: ImageActions.INIT,
			handleAddFrame: ImageActions.ADD_FRAME
		});
	}

	handleInit() {
		// console.log("handleInit");
		this.isLoading = true;
	}

	handleAddFrame({ frame, image }) {
		//console.log("store adding frame", frame);
		this.frames[frame] = image;
		this.framesLoaded = this.frames.length;
		if (this.frames.length === this.frameCount) this.isLoading = false;
	}
}

module.exports = alt.createStore(ImageStore, "ImageStore");
